import React, { useRef, useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Mic, MicMute, CameraVideo, CameraVideoOff, EmojiSmile, Sun, Moon } from 'react-bootstrap-icons';
import EmojiPicker from 'emoji-picker-react';

function VideoChat() {
  const [isMuted, setIsMuted] = useState(false);
  const [isVideoOff, setIsVideoOff] = useState(false);
  const [inputMessage, setInputMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [isDarkTheme, setIsDarkTheme] = useState(true);
  const [isTyping, setIsTyping] = useState(false);
  const chatMessagesRef = useRef(null);

  const sendMessage = () => {
    if (inputMessage.trim()) {
      setMessages([...messages, { sender: 'You', text: inputMessage }]);
      setInputMessage('');
      setShowEmojiPicker(false);
    }
  };

  const toggleMute = () => setIsMuted(!isMuted);
  const toggleVideo = () => setIsVideoOff(!isVideoOff);
  const toggleTheme = () => setIsDarkTheme(!isDarkTheme);

  const handleEmojiClick = (emoji) => {
    setInputMessage(inputMessage + emoji.emoji);
  };

  const handleInputChange = (e) => {
    setInputMessage(e.target.value);
    setIsTyping(e.target.value.trim() !== '');
  };

  // Auto-scroll chat to the bottom
  useEffect(() => {
    if (chatMessagesRef.current) {
      chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className={`video-chat-container ${isDarkTheme ? 'dark' : 'light'}`}>
      <div className="video-grid">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((id) => (
          <div className={`video-tile ${id === 1 ? 'host' : ''}`} key={id}>
            <div className="video-feed">
              <img src={`https://randomuser.me/api/portraits/men/${id}.jpg`} alt="User" className="user-avatar" />
            </div>
            <span className="user-name">User {id} {id === 1 && '(Host)'}</span>
          </div>
        ))}
      </div>

      <div className="chat-panel">
        <div className="chat-header">
          Chat
          <button className="theme-toggle" onClick={toggleTheme}>
            {isDarkTheme ? <Sun /> : <Moon />}
          </button>
        </div>
        <div className="chat-messages" ref={chatMessagesRef}>
          {messages.map((message, index) => (
            <div className="message" key={index}>
              <span className="user">{message.sender}:</span>
              <p>{message.text}</p>
            </div>
          ))}
          {isTyping && <div className="typing-indicator">Someone is typing...</div>}
        </div>
        <div className="chat-input">
          <button className="emoji-button" onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
            <EmojiSmile />
          </button>
          {showEmojiPicker && (
            <div className="emoji-picker">
              <EmojiPicker onEmojiClick={handleEmojiClick} />
            </div>
          )}
          <input
            type="text"
            placeholder="Send a message..."
            value={inputMessage}
            onChange={handleInputChange}
            onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
          />
          <button onClick={sendMessage}>Send</button>
        </div>
      </div>

      <div className="video-controls">
        <button className="control-button" onClick={toggleMute}>
          {isMuted ? <MicMute /> : <Mic />}
        </button>
        <button className="control-button" onClick={toggleVideo}>
          {isVideoOff ? <CameraVideoOff /> : <CameraVideo />}
        </button>
      </div>
    </div>
  );
}

export default VideoChat;